



























































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Rules from '@/shared/rules/rules';
import Justify from '@/domain/justify/domain/justify.entity';
import JustifyService from '@/domain/justify/service/justify.service';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import ReasonsCancellationService from '@/domain/justify/service/reasons-cancellation.service';
import ReasonsCancellation from '@/domain/justify/domain/reasons-cancellation.entity';

@Component({
  components: {
    ModalComponent,
  },
})
export default class ReasonsCancellationModal extends Vue {
  @Prop({ required: true, default: '' }) reasonCancellationId!: string;

  @Prop({ required: true, default: false }) showModal!: boolean;

  @Prop({ required: true, default: '' }) businessUnitId!: string;

  rules: Rules = new Rules();

  loadingOk: boolean = false;

  valid: boolean = true;

  ref: any = this.$refs;

  justifications: Justify[] = [];

  identifier: string = '';

  description: string = '';

  justificationsSelected: string[] = [];

  justificationsRequiredError: boolean = false;

  created() {
    this.loadJustifications();

    if (this.reasonCancellationId !== '') {
      ReasonsCancellationService.getById(this.businessUnitId, this.reasonCancellationId)
        .then((response: ReasonsCancellation) => {
          this.identifier = response.name;
          this.description = response.description;
          if (response.justifications) {
            this.justificationsSelected = response.justifications.map((j) => j.id);
          }
        });
    }
  }

  save() {
    this.justificationsRequiredError = false;
    if (this.justificationsSelected.length === 0) {
      this.justificationsRequiredError = true;
      return;
    }
    if (this.ref.form.validate()) {
      const reasonsCancellation = {
        id: this.reasonCancellationId,
        name: this.identifier,
        description: this.description,
        justifications: this.justificationsSelected,
      }

      if (this.reasonCancellationId === '') {
        ReasonsCancellationService.createReasonsCancellation(
          this.businessUnitId,
          reasonsCancellation,
        )
          .then((response) => {
            if (response && response.status !== 200) {
              VbSnackbarService.showError(response.messages[0] || 'Erro ao criar detalhamento de motivo de cancelamento.');
              return;
            }

            VbSnackbarService.showSuccess('Detalhamento de motivo de cancelamento salvo com sucesso!');
            this.closeModal();
          })
          .catch((error) => {
            VbSnackbarService.showError('Erro ao criar detalhamento de motivo de cancelamento.');
          });

        return;
      }

      ReasonsCancellationService.updateReasonsCancellation(
        this.businessUnitId,
        this.reasonCancellationId,
        reasonsCancellation,
      )
        .then((response) => {
          if (response && response.status !== 200) {
            VbSnackbarService.showError(response.messages[0] || 'Erro ao criar detalhamento de motivo de cancelamento.');
            return;
          }

          VbSnackbarService.showSuccess('Detalhamento de motivo de cancelamento salvo com sucesso!');
          this.closeModal();
        })
        .catch(() => {
          VbSnackbarService.showError('Erro ao criar detalhamento de motivo de cancelamento.');
        });
    }
  }

  closeModal() {
    this.$emit('close');
  }

  loadJustifications() {
    JustifyService.getJustificationsByBusinessUnitAndType(
      this.businessUnitId,
      JustifyType.CONTRACT_MARKED_EXPIRE,
    )
      .then((response: Justify[]) => this.justifications = response)
  }

  get options(): ModalOptions {
    return {
      title: 'Novo Detalhamento de Motivo de Cancelamento',
      titleAlign: 'center',
      showClose: true,
      showOk: true,
      loadingOk: this.loadingOk,
      disabledOk: !this.valid,
      labelOk: 'Confirmar',
      okColor: 'bluePrimary',
      showCancel: !this.loadingOk,
      labelCancel: 'Cancelar',
      width: 800,
      persistent: true,
    }
  }
}
